// eslint-disable-next-line no-restricted-imports
import { toImageCdnSrc } from '@peloton/images/toImageCdnSrc';

type ImageTransformOptions = {
  color?: string;
  crop?: string;
  dpr?: number;
  effect?: string;
  fetchFormat?: string;
  format?: string;
  height?: number;
  quality?: string | number;
  width?: number;
  x?: number;
  y?: number;
};

/**
 * Service-agnostic image URL builder. Reads IMAGE_CDN_BASE_URL from env,
 * so the underlying CDN (Cloudinary, PixelForge, etc.) can be switched by
 * changing that env var without a code deploy.
 *
 * DO NOT use both width and height simultaneously or aspect ratio may be wrong.
 */
export const toImageCdnUrl = (
  imageUrl: string,
  transformations: ImageTransformOptions = {},
  blur: number | null = null,
): string =>
  toImageCdnSrc(
    {
      src: imageUrl,
      crop: (transformations.crop ?? 'scale') as any,
      ...(transformations.dpr != null && {
        devicePixelRatio: transformations.dpr as any,
      }),
      color: transformations.color as any,
      effect: transformations.effect as any,
      format: (transformations.format ?? transformations.fetchFormat ?? 'auto') as any,
      height: transformations.height as any,
      quality: (transformations.quality ?? 'auto') as any,
      width: transformations.width as any,
      x: transformations.x as any,
      y: transformations.y as any,
    },
    blur,
  );
